module.exports = __webpack_public_path__ + "pc/img/about_solution03.00a46baf.jpg";